export function convertAllStringsInObjectToBigInt(obj: any) {
  const newObj = { ...obj }
  for (const key in newObj) {
    if (typeof newObj[key] === 'string') newObj[key] = BigInt(newObj[key])
  }
  return newObj
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
